import React, { Component }  from 'react';
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";


function ProtectedRoute({ children }) {

    // Redux State 
    const userData = useSelector(state => state.auth.data);
    const token = useSelector(state => state.auth.token);
    const isLogin = useSelector(state => state.auth.isLogin);

    

    return token.length > 0 && isLogin == true ?
        children
    :
    <Navigate to="/signin" replace />
}

export default ProtectedRoute;